var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import React, { useState } from 'react';
import styled from 'styled-components';
import { Label } from '../Label';
import { BaseTextInput, BaseTextArea, FormTextElementWrapper, } from './BaseFormText';
import { FormTextProvider } from './context';
import { useFormText } from './useFormText';
import { filterFormTextProps } from './utils';
var StyledLabel = styled(Label)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  white-space: nowrap;\n"], ["\n  white-space: nowrap;\n"])));
var FormText = React.forwardRef(function (props, ref) {
    var internalRef = React.useRef(null);
    var combinedRef = function (node) {
        if (typeof ref === 'function') {
            ref(node);
        }
        if (ref && typeof ref === 'object') {
            ref.current = node;
        }
        internalRef.current = node;
    };
    var _a = __read(useState(false), 2), isFocused = _a[0], setFocused = _a[1];
    var _b = __read(useState(false), 2), isHovered = _b[0], setHovered = _b[1];
    var _c = useFormText(__assign(__assign({}, props), { internalRef: internalRef, isFocused: isFocused, isHovered: isHovered })), variant = _c.variant, labelContent = _c.labelContent, className = _c.className, formTextId = _c.formTextId, describedBy = _c.describedBy, hasError = _c.hasError, isDisabled = _c.isDisabled, formFieldHelper = _c.formFieldHelper, inlineContextualHelp = _c.inlineContextualHelp, characterCounter = _c.characterCounter, characterCounterWidth = _c.characterCounterWidth;
    var inputWidth = props.inputWidth;
    return (React.createElement(FormTextProvider, { className: className, hasError: hasError, isDisabled: isDisabled, isFocused: isFocused, isHovered: isHovered, setFocused: setFocused, setHovered: setHovered },
        React.createElement(StyledLabel, { htmlFor: formTextId }, labelContent),
        React.createElement(FormTextElementWrapper, { formTextElement: variant === 'input' ? (React.createElement(BaseTextInput, __assign({}, filterFormTextProps(props), { id: formTextId, "aria-describedby": describedBy, characterCounterWidth: characterCounterWidth, ref: combinedRef }))) : (React.createElement(BaseTextArea, __assign({}, filterFormTextProps(props), { id: formTextId, "aria-describedby": describedBy, ref: combinedRef }))), formFieldHelper: formFieldHelper, inlineContextualHelp: inlineContextualHelp, characterCounter: characterCounter, inputWidth: inputWidth })));
});
export { FormText };
var templateObject_1;
//# sourceMappingURL=FormText.js.map